import { authHandlers } from './auth/index';
import { userHandlers } from './user';
import { transferHandlers } from './transfer';
import { loanHandlers } from './loans';
import { checkbookHandlers } from './checkbook';
import { checkbookRequestFlowHandlers } from './checkbookRequestFlow';
import { statementsHandlers } from './statements';
import { idempotencyHandlers } from './idempotency';

export const handlers = [
  ...authHandlers,
  ...userHandlers,
  ...transferHandlers,
  ...loanHandlers,
  ...checkbookHandlers,
  ...checkbookRequestFlowHandlers,
  ...statementsHandlers,
  ...idempotencyHandlers,
];
